<div class="key-value grid main-info">
    <div class="key">{{'У списку користувачів:'}}</div>
    <div class="value">
        <ng-container *ngIf="searchResult?.profile?.id">
            {{searchResult.profile?.lastName}} {{searchResult.profile?.firstName}} {{searchResult.profile?.paternalName ? searchResult.profile?.paternalName : ''}}
            {{searchResult.profile?.status && searchResult.profile?.status != 'ACTIVE' ? ('modules.clients.users.list.status.' + searchResult.profile?.status | translate) : ''}}
        </ng-container>
        <ng-container *ngIf="!searchResult?.profile?.id">
            не знайдено
        </ng-container>
    </div>

    <div class="key">{{'У списку контактів:'}}</div>
    <div class="value">
        <ng-container *ngIf="searchResult?.contact">
            <div class="clickable" (click)="openCrmItem('CONTACT', searchResult.contact!.id!)">{{searchResult.contact?.name}}</div>
        </ng-container>
        <ng-container *ngIf="!searchResult?.contact">
            не знайдено
        </ng-container>
    </div>
</div>
